import { fourPlaceHolder } from "modules/utilities/utility";
import React from "react";
import NoData from "assets/svgs/no_data/NoData";
import moment from "moment";
import { Link } from "react-router-dom";

function DeliveryPlanTable({ deliveryFeedbackData, isLoading }) {
  return (
    <div>
      <div className="mt-2">
        <div className="mt-1 shadow">
          <div className="d-flex border rounded-top table-head">
            <span className="p-3 fw-bold text-black flex-1">Customer Name</span>
            <span className="p-3 fw-bold text-black flex-1">
              Customer Phone
            </span>
            <span className="p-3 fw-bold text-black flex-1 text-center">
              On Time Delivery
            </span>
            <span className="p-3 fw-bold text-black flex-1 text-center">
              Delivery Experience
            </span>
            <span className="p-3 fw-bold text-black flex-1">
              Notification Received
            </span>
            <span className="p-3 fw-bold text-black flex-1">Created At</span>
          </div>
          {isLoading ? (
            fourPlaceHolder()
          ) : deliveryFeedbackData?.length ? (
            deliveryFeedbackData?.map((order, index) => {
              return (
                <div
                  className={`d-flex table-row border-bottom border-top-1 ${
                    index === deliveryFeedbackData?.length - 1 &&
                    "rounded-bottom"
                  }`}
                >
                  <span className="flex-1 p-2 fw-bold">
                    <Link to={`/lead-details/${order?.user?.caseId}`}>
                      <div className="fw-bold text-primary">
                        {" "}
                        {order?.user?.first_name}
                      </div>
                    </Link>
                  </span>
                  <span className="flex-1 text-black p-2">
                    {order?.user?.phone_number}
                  </span>
                  <span className="flex-1 text-black text-center">
                    {order.on_time_delivery}
                  </span>
                  <span className="flex-1 text-black text-center">
                    {order.delivery_experience}
                  </span>
                  <span className="flex-1 text-black p-2 text-center">
                    {order.notification_recieved ? "Yes" : "No"}
                  </span>
                  <span className="flex-1 text-black p-2">
                    {moment(order.createdAt).format("DD/MM/YY HH:mm:ss")}
                  </span>
                </div>
              );
            })
          ) : (
            <div className="p-3 rounded-bottom bg-white text-center">
              No Data Available <NoData />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DeliveryPlanTable;
